import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.924 2.923h13v6.838h-1V3.923h-11v.325h-1V2.923z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m2.924 2.513 8.135 5.177v15.062l-8.135-4.437V2.513zm1 1.821v13.387l6.135 3.347V8.238L3.924 4.335z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.924 12.653v5.865h-5.865v-1h4.865v-4.865h1zm6.311-.946H12.83v-1h9.405v1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m18.668 6.933 4.275 4.274-4.275 4.275-.707-.707 3.568-3.568L17.96 7.64l.707-.707z"
		})
	]
});
export default SvgExit;
